<template>
  <!--
    Bascule segmentée, au dessin de BasculePerimetre (Plans d'actions).
    Pas d'AltTabs ici : son `<nav>` s'intercale entre `role="tablist"` et les
    onglets, et axe-core refuse la structure (aria-required-children/parent).
    Un groupe de boutons à `aria-pressed` dit la même chose, correctement.
  -->
  <div role="group" :aria-label="label" class="inline-flex overflow-hidden rounded-lg border border-slate-200 text-sm dark:border-alt-dark-border">
    <button
      v-for="o in options"
      :key="o.value"
      type="button"
      class="px-3 py-1.5 transition-colors"
      :class="
        modelValue === o.value
          ? 'bg-space-indigo text-white dark:bg-sunflower-gold dark:text-space-indigo'
          : 'bg-white text-slate-700 hover:bg-slate-50 dark:bg-alt-dark-surface dark:text-altoneo-50 dark:hover:bg-alt-dark-raised'
      "
      :aria-pressed="modelValue === o.value"
      @click="$emit('update:modelValue', o.value)"
    >
      {{ o.label }}
    </button>
  </div>
</template>

<script setup lang="ts" generic="T extends string">
defineProps<{ modelValue: T; options: { value: T; label: string }[]; label: string }>();
defineEmits<{ 'update:modelValue': [T] }>();
</script>
